export default __webpack_public_path__ + "static/header-bg-b6acfbf9fb30b2a537f2d80691cb300d.jpg";